import { compose } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { pushParams, removeParams } from 'ggApp/modules/router/actions';
import WaitingListModal from './WaitingListModal';

const enhance = compose(
    connect(null, (dispatch) => ({
        pushUrlParams: bindActionCreators(pushParams, dispatch),
        removeUrlParams: bindActionCreators(removeParams, dispatch),
    })),
);

export default enhance(WaitingListModal);
